package org.example.zone360.pages.authentication

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import org.example.zone360.utils.changeEmail
import com.stevdza.san.kotlinbs.components.showToast
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.InputField
import org.example.zone360.componentss.FieldTitleText
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement


@Composable
fun ChangeEmailPage(
    onDialogDismiss: () -> Unit,
    toastMessage: (String) -> Unit,
) {
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()

    var isEmailError by remember { mutableStateOf(false) }
    var serverMessage by remember { mutableStateOf<String?>(null) }
    var isLoading by remember { mutableStateOf(false) }

    fun performChangeEmail() {

        val current = (document.getElementById(Res.Id.emailInput) as HTMLInputElement).value.trim()

        isEmailError = false
        serverMessage = null

        when {
            current.isBlank()  -> {
                isEmailError = true
                return
            }
            current == AppGlobal.userData.email -> {
                serverMessage = "New email cannot be the same as the current email."
                return
            }
        }

        scope.launch {
            isLoading = true
            try {
                val response = changeEmail(
                    email = current,
                    userID = AppGlobal.userData.uid,
                    organization = AppGlobal.userData.organization
                )
                if (response.success) {
                    toastMessage("Email changed successfully!")
                    showToast("toastSuccess")
                    onDialogDismiss()
                } else {
                    serverMessage = response.error
                }
            } catch (t: Throwable) {
                serverMessage = "Failed to change email: ${t.message}"
            } finally {
                isLoading = false
            }
        }
    }
    Box(
        modifier = Modifier.position(Position.Fixed).top(0.px).left(0.px).width(100.percent)
            .height(100.percent).zIndex(999)
            .backgroundColor(Palette.Grey.rgbLight.copyf(alpha = 0.7f)),
        contentAlignment = Alignment.Center
    ) {
        Box(modifier = Modifier.width(460.px).position(Position.Fixed).zIndex(9).top(50.percent)
            .left(50.percent).transform { translate((-50).percent, (-50).percent) }
            .borderRadius(6.px).padding(30.px), contentAlignment = Alignment.Center) {
            Box(
                Modifier.color(Colors.Black).backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .maxWidth(400.px).border(
                        width = 1.px,
                        color = sitePalette.textFieldBorderColor.rgb,
                        style = LineStyle.Solid
                    ).borderRadius(6.px), contentAlignment = Alignment.Center
            ) {
                Column(
                    modifier = Modifier.padding(topBottom = 30.px, leftRight = 30.px),
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(bottom = 25.px),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleText(text = "Change Email", marginBottom = 0.px)
                        FaXmark(
                            modifier = Modifier.color(sitePalette.commonButtonSupportiveTextColor.rgb)
                                .cursor(Cursor.Pointer).onClick { onDialogDismiss() },
                            size = IconSize.LG
                        )
                    }
                    Row(
                        Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                    ) {
                        FieldTitleTextNormal(text = "New Email") {}
                    }
                    InputField(
                        onValueChange = {
                            serverMessage = null
                        },
                        errorText = "Please enter your new email",
                        inputType = InputType.Email,
                        placeHolder = "",
                        id = Res.Id.emailInput,
                        isError = isEmailError,
                        marginBottom = 3.px,
                        onEnterPress = ::performChangeEmail
                    )


                    Box(Modifier.margin(topBottom = 10.px)) { }
                    CommonButton(
                        byPassEmailVerification = true,
                        text = "Change Email",
                        isLoading = isLoading,
                        onCLick = ::performChangeEmail
                    )
                    serverMessage?.let {
                        FieldTitleTextNormalSimple(
                            width = 100.percent,
                            textAlign = TextAlign.Center,
                            text = it, color = if (it.contains(
                                    "success", ignoreCase = true
                                )
                            ) sitePalette.primary.rgb else sitePalette.textErrorColor.rgb
                        )
                    }

                }
            }
        }
    }
}


